import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../axiosConfig";

/**
 * Resolves the service the details page should show.
 *
 * In-app navigation passes the whole service in router state. A link from outside the page —
 * a chatbot answer, the help centre, a shared URL — only carries ?serviceId=, so the service is
 * looked up in the guide instead. Without either, there is nothing to show and the guide opens.
 */
const useServiceGuideEntry = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const serviceId = new URLSearchParams(location.search).get("serviceId");
  const stateService = location.state;

  const [service, setService] = useState(stateService || null);
  const [isLoading, setIsLoading] = useState(!stateService && !!serviceId);

  useEffect(() => {
    if (stateService) {
      setService(stateService);
      setIsLoading(false);
      return;
    }

    if (!serviceId) {
      navigate("/services-guide", { replace: true });
      return;
    }

    let active = true;
    setIsLoading(true);
    axiosInstance
      .get("/MunicipalityService/MunicipalityServicesGuide")
      .then((data) => {
        if (!active) return;
        const wanted = String(serviceId).toLowerCase();
        const match = (Array.isArray(data) ? data : [])
          .flatMap((category) => category?.publicServices || [])
          .find((item) => String(item?.serviceId || "").toLowerCase() === wanted);

        if (match) {
          setService(match);
        } else {
          navigate("/services-guide", { replace: true });
        }
      })
      .catch(() => {
        if (active) navigate("/services-guide", { replace: true });
      })
      .finally(() => {
        if (active) setIsLoading(false);
      });

    return () => {
      active = false;
    };
  }, [serviceId, stateService, navigate]);

  return { service, isLoading };
};

export default useServiceGuideEntry;
